import { render, staticRenderFns } from "./codigosLR.vue?vue&type=template&id=157d9b27"
import script from "./codigosLR.vue?vue&type=script&lang=js"
export * from "./codigosLR.vue?vue&type=script&lang=js"
import style0 from "./codigosLR.vue?vue&type=style&index=0&id=157d9b27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports